import styled from 'styled-components';
import {ListTitleDefaultBox}  from "./list-title.default.box";

export const ListTitleCisBox = styled(ListTitleDefaultBox)`
    &:before {
      display: none;
    }
    
    border-top: 1.5px solid ${props => props.theme.colors.brandPrimary};
    background-color: ${props => props.theme.colors.background};
`;
